import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

// Non-cached SSR provides the token via Redux (isomorphic/index.html.slim passes it in
// props); cached SSR sees Redux empty and lets the useEffect fill in from the meta tag.
const AuthToken = () => {
  const reduxToken = useSelector(({ auth }) => auth.csrfToken) || ''
  const [token, setToken] = useState(reduxToken)

  useEffect(() => {
    if (token) return
    const meta = document.querySelector('meta[name=csrf-token]')
    const value = meta && meta.getAttribute('content')
    if (value) setToken(value)
  }, [])

  return <input type="hidden" name="authenticity_token" value={token} />
}

export default AuthToken
